import { Component, Input } from '@angular/core';
import { DropdownModule, GridModule } from '@coreui/angular-pro';
import { cibCoderwall, cilList } from '@coreui/icons';
import { IconDirective } from '@coreui/icons-angular';
import { AuthService } from '../../services/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { IModuleItemExtened, IModulePermissions, UserProfileModel } from '../../models/user-cust-model';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-dl-module-selector',
  standalone: true,
  imports: [CommonModule, DropdownModule, GridModule, IconDirective,],
  templateUrl: './dl-module-selector.component.html',
  styleUrl: './dl-module-selector.component.scss'
})
export class DlModuleSelectorComponent {
  private profile$ = new Subject<any>();
  icons = { cibCoderwall, cilList };
  dlWebUrl = environment.dlWebAppUrl;
  defectWebUrl = environment.defectWebAppUrl;
  siWebUrl = environment.siWebAppUrl;
  userProfile: UserProfileModel | null = null;
  hasModules = false;
  // ALl module avalible onDL
  allModules: IModuleItemExtened[] = [
    {
      displayName: 'Track',
      name: 'Track',
      url: `${this.dlWebUrl}/telmatics/track`,
      image: '/assets/images/track-icon.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Track Asset',
      name: 'Track Asset',
      url: `${this.dlWebUrl}/track-vehicle`,
      image: '/assets/images/track-icon.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Trace',
      name: 'Trace',
      url: `${this.dlWebUrl}/trace`,
      image: '/assets/images/trace-icon.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Trace Asset',
      name: 'Trace Vehicle',
      url: `${this.dlWebUrl}/track-vehicle`,
      image: '/assets/images/trace-icon.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Geofence',
      name: 'Geofence',
      url: `${this.dlWebUrl}/telematics/geofence`,
      image: '/assets/images/geofence-icon.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Timesheets',
      name: 'Timesheets',
      url: `${this.dlWebUrl}/telematics/timesheets`,
      image: '/assets/images/time-shets-icon.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Trips/Stops',
      name: 'Trips',
      url: `${this.dlWebUrl}/telematics/trip`,
      image: '/assets/images/time-shets-icon.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Check It',
      name: 'Vehicle Check',
      url: `${this.dlWebUrl}/vehiclecheck/`,
      image: '/assets/images/vehicle-check-icon--white.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Mobileye ADAS',
      name: 'Mobileye ADAS',
      url: `${this.dlWebUrl}/telematics/safety/mobileye`,
      image: '/assets/images/mobileye-icon--white1.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Driver Behaviour',
      name: 'Driver Behaviour',
      url: `${this.dlWebUrl}/telematics/safety/abc`,
      image: '/assets/images/driver-behaviour-icon--white.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Events',
      name: 'Events',
      url: `${this.dlWebUrl}/events/activity`,
      image: '/assets/images/events-icon--white.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Video',
      name: 'videos',
      url: `${this.dlWebUrl}/video/historic`,
      image: '/assets/images/video-icon.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Vehicle File',
      name: 'Vehicle File',
      url: `${this.dlWebUrl}/vehicle-file/activity`,
      image: '/assets/images/video-file-icon.png',
      project: 'DATALIVE',
      enabled: false
    },
    {
      displayName: 'Defect App',
      name: 'Defect',
      url: `${this.defectWebUrl}`,
      image: '/assets/images/video-file-icon.png',
      project: 'DATALIVE',
      enabled: false
    }



  ]

  constructor(private auth: AuthService) {

  }

  ngOnInit() {

    this.auth.user$.pipe(
      takeUntil(this.profile$)
    ).subscribe({
      next: (data) => {
        this.userProfile = data;

        const modules = data?.modules ? data?.modules : [];
        this.hasModules = modules.length > 0 ? true : false;
        this.updateUserModules(modules);
        // this.cdr.detectChanges()
      }
    });
  }

  updateUserModules(modules: IModulePermissions) {

    const usersModules = this.allModules.map(item => {
      let item2 = modules.find(i2 => i2.name === item.name);
      if (item2) {
        item.enabled = true;
      }
      return item;
    });

    // console.log('updateUserModules: usersModules: ', usersModules)


  }

}
